import { FC } from "react";
import { Box, Typography } from "@mui/material";

import { RiLockLine } from "react-icons/ri";
import ChevronRightIcon from "../../../../icons/ChevronRightIcon";

import { ClaimAppealLetter } from "../../../../../types/claims";
import { formatDisplayDate } from "../../../../helpers/dataHelper";
import Row from "../../../../ui/core/Row";
import CardChip from "../CardChip";
import { getCardSx } from "../ediCardStyles";

// 1 -> "1 version", 3 -> "3 versions"
export const formatVersionCount = (count: number) =>
  `${count} ${count === 1 ? "version" : "versions"}`;

// A single clickable card summarising one chat's appeal letter in the Claim timeline:
// when it was first generated, by whom, and how many versions it has
const AppealLetterCard: FC<{
  letter: ClaimAppealLetter;
  onClick: () => void;
}> = ({ letter, onClick }) => (
  <Box
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") onClick();
    }}
    sx={getCardSx("custom.cardBorder")}
  >
    <Box sx={{ minWidth: 0 }}>
      <Row sx={{ alignItems: "center", gap: 1 }}>
        <Typography sx={{ fontSize: "0.8125rem", fontWeight: 600 }}>
          Appeal letter
        </Typography>
        <CardChip
          chip={{
            label: formatVersionCount(letter.versionCount),
            kind: "default",
          }}
        />

        {!letter.available && (
          <Box
            component="span"
            title="In a private chat"
            sx={{ display: "inline-flex", color: "text.secondary" }}
          >
            <RiLockLine size={14} aria-label="In a private chat" />
          </Box>
        )}
      </Row>

      <Typography
        variant="caption"
        color="text.secondary"
        noWrap
        component="div"
        sx={{ fontSize: "0.7rem", paddingTop: "7px" }}
      >
        First generated {formatDisplayDate(letter.generatedAt)}
        {letter.generatedBy || letter.generatedByEmail
          ? ` · by ${letter.generatedBy || letter.generatedByEmail}`
          : ""}
      </Typography>
    </Box>

    <ChevronRightIcon className="w-4 h-4 text-gray-400 shrink-0" />
  </Box>
);

export default AppealLetterCard;
